import React from 'react';
import PpcFarmCohortBuilderClient from '../../components/ppc-farm/PpcFarmCohortBuilderClient';

const PpcFarmCohortBuilderPage: React.FC = () => {
  return <PpcFarmCohortBuilderClient />;
};

export default PpcFarmCohortBuilderPage;